import React, { useState, useEffect } from "react";
import { useFirebase } from "../context/firebase.context";

const PhotoGallery = () => {
    const { displayPhotos, deletePhoto, deleteAllPhotosInCategory } = useFirebase();
    const [media, setMedia] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchMedia();
    }, []);

    const fetchMedia = async () => {
        setLoading(true);
        try {
            const fetchedMedia = await displayPhotos(); // Fetch both images and videos
            setMedia(fetchedMedia);
        } catch (error) {
            console.error("Error fetching media:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (mediaId) => {
        try {
            await deletePhoto(mediaId);
            fetchMedia(); // Refresh media list
        } catch (error) {
            console.error("Error deleting media:", error);
        }
    };

    const handleDeleteAllInCategory = async (category) => {
        try {
            await deleteAllPhotosInCategory(category);
            fetchMedia(); // Refresh media list
        } catch (error) {
            console.error("Error deleting all media in category:", error);
        }
    };

    // Group media by category, excluding empty categories
    const groupMediaByCategory = (media) => {
        return media.reduce((acc, item) => {
            const { category } = item;
            if (!acc[category]) {
                acc[category] = [];
            }
            acc[category].push(item);
            return acc;
        }, {});
    };

    const groupedMedia = groupMediaByCategory(media);

    return (
        <div className="container my-5">
            <h2 className="text-center mb-4 mt-3">Media Manager</h2>

            {loading ? (
                <p className="text-center">Loading media...</p>
            ) : (
                <div>
                    {Object.keys(groupedMedia).length > 0 ? (
                        Object.keys(groupedMedia).map((category) => (
                            groupedMedia[category].length > 0 && ( // Only display if category has media
                                <div key={category} className="mb-5">
                                    <h3 className="mb-3">{category}</h3>
                                    <button
                                        onClick={() => handleDeleteAllInCategory(category)}
                                        className="btn btn-danger mb-3"
                                    >
                                        Delete All in {category}
                                    </button>
                                    <div className="row">
                                        {groupedMedia[category].map((item) => (
                                            <div key={item.id} className="col-md-4 col-sm-6 mb-4">
                                                <div className="card shadow-sm">
                                                    <div className="card-img-container">
                                                        {item.type === "image" ? (
                                                            <img
                                                                src={item.imageUrl}
                                                                alt={item.category}
                                                                className="card-img-top img-fluid rounded"
                                                                style={{ objectFit: "cover", height: "200px" }}
                                                            />
                                                        ) : (
                                                            <video
                                                                controls
                                                                src={item.imageUrl}
                                                                className="card-img-top img-fluid rounded"
                                                                style={{ objectFit: "cover", height: "200px" }}
                                                            >
                                                                Your browser does not support the video tag.
                                                            </video>
                                                        )}
                                                    </div>
                                                    <div className="card-body">
                                                        <button
                                                            onClick={() => handleDelete(item.id)}
                                                            className="btn btn-danger w-100"
                                                        >
                                                            Delete {item.type === "image" ? "Photo" : "Video"}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )
                        ))
                    ) : (
                        <p className="text-center">No media uploaded yet.</p>
                    )}
                </div>
            )}
        </div>
    );
};

export default PhotoGallery;
